import type {ReactElement} from 'react';
import React from 'react';
import {AddButton} from '@Components/add-button';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import {openPosterAddItemsModal} from '@Modals/poster-add-items-modal';
import {Text, TextSize, TextType} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import styles from './poster-editor-add-item-button.module.scss';

interface PosterEditorAddItemButtonProps {
  showSkeletonState?: boolean;
  isItemSelected?: boolean;
}

export function PosterEditorAddItemButton({showSkeletonState = false, isItemSelected = false}: PosterEditorAddItemButtonProps): ReactElement<any> {
  const onClickHandler = (): void => {
    openPosterAddItemsModal({});
  };

  const onClearSelection = (): void => {
    window.posterEditor?.whiteboard?.clearSelection();
  };

  const getContent = (): ReactElement<any> => {
    if (showSkeletonState) {
      return <SkeletonBrick theme={SkeletonBrickTheme.LIGHT_TWO} width={48} height={48} radius="100px" />;
    }

    if (isItemSelected) {
      return (
        <ClickableDiv className={`_full-width _full-height flex-v-row flex-center ${styles.borderRight}`} onClick={onClearSelection}>
          <div className={`flex-center radius-round ${styles.clearSelectionButton}`}>
            <Icon icon="icon-clear-selection" size={IconSize.SIZE_ICON_24} />
          </div>
          <Text className="text-center" val={window.i18next.t('pmwjs_clear_selection')} size={TextSize.SM} type={TextType.BODY} />
        </ClickableDiv>
      );
    }

    return (
      <>
        <div className={`flex-center _full-width ${styles.borderRight}`}>
          <AddButton onClick={onClickHandler} />
        </div>
        <Text className={styles.addText} val="Add" size={TextSize.XXSMALL} />
      </>
    );
  };

  return (
    <div className={styles.addButton}>
      <div className={styles.wrapperContainer}>{getContent()}</div>
    </div>
  );
}
